import React, { Fragment } from 'react';
import './index.scss';
const Loading = (props) => {
    const { content, color, style, show } = props;
    return show ? (React.createElement("div", { className: "netapp-loading", style: style },
        React.createElement("div", { className: "netapp-loading-wrap" },
            React.createElement("div", { className: "am-dot-spin am-dot-spin-lg am-dot-spin-spinning" },
                React.createElement("span", { className: "am-dot-spin-dot am-dot-spin-dot-spin" },
                    React.createElement("i", { className: "am-dot-spin-dot-item", style: { backgroundColor: color } }),
                    React.createElement("i", { className: "am-dot-spin-dot-item", style: { backgroundColor: color } }),
                    React.createElement("i", { className: "am-dot-spin-dot-item", style: { backgroundColor: color } }),
                    React.createElement("i", { className: "am-dot-spin-dot-item", style: { backgroundColor: color } }))),
            React.createElement("div", { className: "netapp-loading-title", id: "production-name" }, content)))) : (React.createElement(Fragment, null));
};
export default Loading;
